export default __webpack_public_path__ + "static/media/logo_chambre_metier_artisanat_normandie.9fb33339.svg";